module.exports = __webpack_public_path__ + "img/H1.3c78e5d0.png";